import { defineComponent as _defineComponent } from 'vue'
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import { computed, PropType, toRefs } from 'vue';
import useUser from '@/mixins/useUser';
import { LatestUserDashboard } from '@/views/home/models/Dashboard';
import { truncate } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardNewMember',
  props: {
  dashboardUser: {
    type: Object as PropType<LatestUserDashboard>,
    required: true
  },
  isCurrent: Boolean
},
  emits: ['show-info'],
  setup(__props, { emit }) {

const props = __props;





const { isCurrent } = toRefs(props);

const user = computed(() => props.dashboardUser.externalUserBanner);
const profile = computed(() => props.dashboardUser.externalUserProfile);

const { displayName, tUserFallback: t } = useUser(user);

const profileSummary = computed(() => profile.value?.basic?.profileSummary);

const summary = computed(() => {
  if (profileSummary.value) {
    return truncate(profileSummary.value, { length: 100 });
  }
  return t('profile.basic_USERTYPE.emptyTextView').toString();
});


return { __sfc: true,props, emit, isCurrent, user, profile, displayName, t, profileSummary, summary, BCXAvatar }
}

})